import apiClient from '../axios.js';

export const couponTemplateService = {
  /**
   * 查詢優惠券模板列表
   * @param {Object} params - 查詢參數
   * @param {number} params.page - 頁碼
   * @param {number} params.pageSize - 每頁筆數
   * @param {string} params.couponType - 優惠券類型
   * @param {boolean} params.isActive - 是否啟用
   * @param {string} params.search - 搜尋關鍵字
   * @returns {Promise<Object>} 優惠券模板列表
   */
  getCouponTemplates: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.pageSize) queryParams.append('pageSize', params.pageSize);
    if (params.couponType) queryParams.append('couponType', params.couponType);
    if (params.isActive !== undefined) queryParams.append('isActive', params.isActive);
    if (params.search) queryParams.append('search', params.search);

    const queryString = queryParams.toString();
    const url = `/admin/coupons/templates${queryString ? `?${queryString}` : ''}`;
    const response = await apiClient.get(url);
    return response;
  },

  /**
   * 查詢優惠券模板詳情
   * @param {string} templateId - 模板 ID
   * @returns {Promise<Object>} 優惠券模板詳情
   */
  getCouponTemplate: async (templateId) => {
    const response = await apiClient.get(`/admin/coupons/templates/${templateId}`);
    return response;
  }
};
